import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseVerticalAlignmentOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-vertical-alignment-option';
import type {TextVerticalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextItem} from '@Hooks/poster-editor/useGetKeyFromTextItem';

interface TextVerticalAlignmentOptionProps {
  showLargeIcons?: boolean;
  text?: string;
}

export function TextVerticalAlignmentOption({showLargeIcons = false, ...props}: TextVerticalAlignmentOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const verticalAlign = useGetKeyFromTextItem('verticalAlign');

  if (!activeItem || (activeItem && !('verticalAlign' in activeItem)) || verticalAlign === undefined) {
    throw new Error(`Item doesn't have vertical align property`);
  }

  const onClickHandler = (clickedId: TextVerticalAlignType): void => {
    void activeItem.updateFromObject({
      verticalAlign: clickedId,
    });
  };

  return <ItemBaseVerticalAlignmentOption text={props.text} showLargeIcons={showLargeIcons} selectedAlignment={verticalAlign} onClickAlignmentOption={onClickHandler} />;
}
